module.exports = __webpack_public_path__ + "static/media/medalha-prata.fadc2659.svg";